import {
	nfFormsPushInterceptor,
	buildSetStateHook,
	buildFormConditions,
	findDisclaimerKey,
	findDisclaimerHtml,
	findSubmitButtonKey,
	buildFormLayout,
	getFormPrefixId,
	buildFields,
	buildNextButtonControllerClass,
	findMessageKey,
} from './ai-enhanced-form-fields/index';
import { AdobeEvents as AdobeEventsClass } from './../utils/adobe-events';

const $ = jQuery;

const log = (message) => {
	window.console.log(`Business logic of AI Enhanced forms: ${message}`);
};
/**
 *
 * Adds AI related fields to the form, see: https://dev.azure.com/tr-legal-tech/FindLaw/_workitems/edit/412294
 *
 * This script overloads the standard behavior of registering Ninja-Forms via `nfForms.push` call
 *
 * It also adds the conditions that control the UI of the form fields.
 *
 * The AI-related fields got injected into the form layout, before the disclaimer checkbox.
 *
 * @function init
 */
export default function () {
	if ($('.ENABLE_AI_ENHANCED_FORM').length === 0) {
		return;
	}
	window.nfForms = window.nfForms || [];
	nfFormsPushInterceptor((form) => {
		log('start');
		if (window.siteFeatureToggles.ENABLE_AI_ENHANCED_FORM !== '1') {
			log('site level feature toggle is disabled, skipping AI enhancements');
			return form;
		}
		const formPrefixId = getFormPrefixId(form.id);
		let enhancedForm = form;
		const messageKey = findMessageKey(enhancedForm.fields);
		// skip the form if the message field is not found
		if (messageKey === false) {
			return enhancedForm;
		}
		if ($('.ENABLE_EDITABLE_LAYOUT_OF_AI_FORMS').length === 0) {
			// Inject the new fields into the form layout, before the disclaimer checkbox
			enhancedForm = buildFormLayout(formPrefixId, enhancedForm);
			// Add the conditions that controls the UI of the form fields
			enhancedForm.settings.conditions = [
				...(enhancedForm.settings.conditions || []),
				...buildFormConditions(
					formPrefixId,
					findDisclaimerKey(enhancedForm.fields),
					findDisclaimerHtml(enhancedForm.fields).key,
					findSubmitButtonKey(enhancedForm.fields),
				),
			];
			// Add the new AI-related fields to the form fields
			enhancedForm.fields = [
				...enhancedForm.fields,
				...buildFields(formPrefixId),
			];
		}
		// Wait for the form to be ready
		$(document).one('nfFormReady', () => {
			const setStateHook = buildSetStateHook(formPrefixId, form.fields);
			const adobeEvents = new AdobeEventsClass();
			try {
				const NextButtonController = buildNextButtonControllerClass();
				const fields = enhancedForm.fields;
				// eslint-disable-next-line no-new
				new NextButtonController({
					formPrefixId,
					fields,
					adobeEvents,
					formId: form.id,
				});
				// Set the state of the form to 'enabled' to trigger the conditions
				setStateHook('enabled');
				log('completed');
			} catch (error) {
				log(`Error initializing Enhanced Forms: ${error}`);
			}
		});
		log('initialized');
		return enhancedForm;
	});
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form.js